module.exports = __webpack_public_path__ + "images/sf_1.gif";